export default __webpack_public_path__ + "static/media/bhagirathiriver.499f441d.jpg";